import React from 'react';
import { Button } from '@m4b-design/components';
import icon from './icon.svg';
import styles from './index.scss';
import {
  useRedirectToSignUp,
  useRedirectToLogin,
} from '@features/hooks/useRedirectToLogin';
import { useTranslation } from '@jupiter-app/plugin-i18n';

interface LoginWindowProps {
  type?: string;
  className?: string;
  onLogin?: () => void;
  onRegister?: () => void;
}

const LoginWindow: React.FC<LoginWindowProps> = props => {
  const { className, onLogin, onRegister } = props;
  const redirectToLogin = useRedirectToLogin;
  const redirectToSignUp = useRedirectToSignUp;
  const { t } = useTranslation();
  return (
    <div className={styles.loginBox}>
      <div className="flex justify-center">
        <img className={className} src={icon} alt={'user login icon'} />
      </div>
      <div className="mx-32">
        <p className="text-p1-semibold text-neutral-text1 mt-12 mb-4">
          {t('academy_view_permission_page_description_title')}
        </p>
        <p className="text-neutral-text3 text-p4-regular mx-64">
          {t('academy_view_permission_page_description_text')}
        </p>
        <Button
          type={'primary'}
          className="mb-8 mt-12 text-neutral-white"
          style={{ background: 'black' }}
          long
          onClick={() => {
            if (onLogin) {
              onLogin();
            } else {
              redirectToLogin();
            }
          }}>
          {t('academy_view_permission_page_btn_login')}
        </Button>
        <p className="text-p3-regular text-neutral-text1">
          {t('academy_view_permission_page_no_account')}
          <span
            className="text-p3-semibold text-brand-normal ml-4 cursor-pointer"
            onClick={() => {
              if (onRegister) {
                onRegister();
              } else {
                redirectToSignUp();
              }
            }}>
            {t('academy_view_permission_page_btn_sign')}
          </span>
        </p>
      </div>
    </div>
  );
};

export default LoginWindow;
